export function findResourceById(resources, resourceToFindWithId) {
  const a = resourceToFindWithId.split("/");
  const type = a[0];
  const id = a[1];
  return resources.filter(r => r.resourceType === type && r.id === id)[0];
}

export function getBySystem(arr, system) {
  return getBy(arr, system, "system");
}

export function getByUrl(arr, system) {
  return getBy(arr, system, "url");
}

export function getBy(arr, system, byKey) {
  if (!arr || !system) {
    return null;
  }
  return arr.find(identifier => identifier[byKey] === system);
}

export function identifierToString(resource) {
  return `${resource.identifier[0].system}|${resource.identifier[0].value}`;
}

export function getFromExtension(resource, extension, key) {
  return resource.extension.find(e => e.url === extension)[key];
}
/**
 * Transforms a complex FHIR extensions and returns an array of the extension's sub-extensions.
 * Example:
 * {
                        "url": "http://deeppath.cl/fhir/StructureDefinition/pixel-size",
                        "extension": [
                            {
                                "url": "x",
                                "valueDecimal": 0.45641259698767683
                            },
                            {
                                "url": "y",
                                "valueDecimal": 0.45641259698767683
                            }
                        ]
                    }
 * is transformed to: { x: ..., y: ...}
 * @param resource
 * @param extension
 * @returns {*|[]}
 */
export function getFromComplexExtension(resource, extension) {
  const extensions = resource.extension.filter(e => e.url === extension);
  const values = [];
  for (let ext of extensions) {
    const obj = {};
    for (let extension of ext.extension) {
      const key = extension.url;
      const valueKey = Object.keys(extension).filter(e => e !== "url")[0];
      obj[key] = extension[valueKey];
    }
    values.push(obj);
  }
  // flatten array for a single entry
  return values.length === 1 ? values[0] : values;
}

export function referenceToId(reference) {
  return reference.split("/")[1];
}
